import { useQuery } from '@apollo/client'
import { GET_ALL_FORMS } from './queries'
import { Folder } from './types'

export const useAllForms = () => {
  const query = useQuery<{ allFolders: Folder[] }>(GET_ALL_FORMS)
  return query
}
